module.exports = __webpack_public_path__ + "47ca761154e5708dc35f607189002f19.svg";